import React from 'react';
import { getLinkDisplayTitle, linkDomainFromUrl } from '../../utils/fileUtils';

const LinkIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
    />
  </svg>
);

const decodeHref = (url) => (url || '').replace(/&amp;/g, '&');

const TimelineLinkCard = ({
  link,
  onClick,
  className = '',
}) => {
  if (!link?.url) return null;

  const href = decodeHref(link.url);
  const title = getLinkDisplayTitle(link);
  const domain = link.domain || link.siteName || linkDomainFromUrl(href);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(link);
      return;
    }
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={title}
      className={`flex items-center gap-3 w-full max-w-sm px-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/90 hover:bg-gray-50 dark:hover:bg-gray-700/60 transition-colors text-left ${className}`}
    >
      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-50 dark:bg-primary-900/30 flex items-center justify-center">
        {link.imageUrl ? (
          <img
            src={link.imageUrl}
            alt=""
            className="w-full h-full object-cover rounded-lg"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <LinkIcon className="w-5 h-5 text-primary-600 dark:text-primary-400" />
        )}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <p className="text-sm font-semibold text-gray-900 dark:text-white truncate min-w-0">
            {title}
          </p>
          <span className="flex-shrink-0 px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wide bg-primary-50 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300">
            Link
          </span>
        </div>
        {domain && (
          <p className="text-xs text-primary-600 dark:text-primary-400 mt-0.5 truncate">
            {domain}
          </p>
        )}
      </div>
    </button>
  );
};

export { LinkIcon };
export default TimelineLinkCard;
